export const STICKY_BAR_ID = 'dynamic-packages-steps-sticky-bar';
